export default Object.freeze({
  EntityForm: 1,
  EntityFilter: 2,
  FieldForm: 3,
  FieldFilter: 4,
  UserExtraFieldForm: 5,
  ListFilter: 6,
});
